import React from 'react'

function Serie() {
    return (
        <div>
            Create serie
        </div>
    )
}

export default Serie